import React, { useState } from "react"
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Button,
  CardTitle,
  CardText,
  Row,
  Col,
  Container,
} from "reactstrap"
import classnames from "classnames"
import FacilityList from "../faciliities/FacilityList"

const Tabs = (props) => {
  const [activeTab, setActiveTab] = useState("1")

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  return (
    <div className="tabs-padding-top">
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "1" })}
            onClick={() => {
              toggle("1")
            }}
          >
            Facility
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "2" })}
            onClick={() => {
              toggle("2")
            }}
          >
            MyQRs
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <Container>
            <Row>
              <Col sm="12">
                <div className="table-top-padding">
                  <FacilityList />
                </div>
              </Col>
            </Row>
          </Container>
        </TabPane>
        <TabPane tabId="2">
          <Row>
            <Col sm="6">
              <p className="main-dashboard">Coming Soon!</p>
            </Col>
          </Row>
        </TabPane>
      </TabContent>
    </div>
  )
}

export default Tabs
